export default __webpack_public_path__ + "static/media/elevate-blk-4.6b375134.png";